import script from "./LoadingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingPage.vue?vue&type=style&index=0&id=6a6d7d76&lang=css"

const __exports__ = script;

export default __exports__